/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full screen`)
};

const es_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalla completa`)
};

const de_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollbild`)
};

const nl_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledig scherm`)
};

const fr_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plein écran`)
};

const it_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schermo intero`)
};

const pt_br2_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tela cheia`)
};

const pt_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ecrã inteiro`)
};

const ja_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面表示`)
};

const zh_ruler_fullscreen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全屏`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_fullscreen = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_fullscreen(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_fullscreen", locale)
	if (locale === "en") return en_ruler_fullscreen(inputs)
	if (locale === "es") return es_ruler_fullscreen(inputs)
	if (locale === "de") return de_ruler_fullscreen(inputs)
	if (locale === "nl") return nl_ruler_fullscreen(inputs)
	if (locale === "fr") return fr_ruler_fullscreen(inputs)
	if (locale === "it") return it_ruler_fullscreen(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_fullscreen(inputs)
	if (locale === "pt") return pt_ruler_fullscreen(inputs)
	if (locale === "ja") return ja_ruler_fullscreen(inputs)
	return zh_ruler_fullscreen(inputs)
};